// extracted by mini-css-extract-plugin
module.exports = {"option":"styles_option__T9QkA","icon":"styles_icon__1h_nI"};